export default __webpack_public_path__ + "static/media/car-door.cde83cd9.svg";